import Vue from 'vue'
import VueRouter from 'vue-router'

const Backend = ()=>import('@/views/Layout/Backend.vue') /*后端布局页*/
const Front = ()=>import('@/views/Layout/Front.vue')  /*前端布局页*/

Vue.use(VueRouter)

let routes = [
    /*==前台路由配置 Start==*/
    {
        path: '/',
        redirect: '/epmc',
        component: Front,
        hidden: true,
        index: 0,
        children: [
            {
                path: 'login',
                component: ()=>import('@/views/userLogin.vue'),
                name: 'login',
                meta: {
                    title: '用户登陆',
                    isBackend: false,
                    mustAuth: false,
                    showNav: false,
                    hidden: true,
                    index: 0,
                },
            },
            {
                path:"mind",
                component: ()=>import('@/views/Mind.vue'),
                name:'mind',
                meta:{
                    title:"个人首页",
                    isBackend: false,
                    mustAuth: true,
                    showNav: true,
                    hidden: true,
                    index: 1,
                }
            },
            {
                path: 'epmc',
                component: ()=>import('@/views/performance.vue'),
                name: 'epmc',
                meta: {
                    title: '填写工时',
                    isBackend: false,
                    mustAuth: true,
                    hiddenToolbar: false,
                    showNav: true,
                    hidden: true,
                    index: 2,
                },
            },
            {
                path: 'changePwd',
                component: ()=>import('@/views/changePassword.vue'),
                name: 'changePwd',
                meta: {
                    title: '修改密码',
                    isBackend: false,
                    mustAuth: true,
                    showNav: true,
                    hidden: true,
                    index: 3,
                }
            },
            {
                path: 'examineList',
                component: ()=>import('@/views/ManageExamineList.vue'),
                name: 'examineList',
                meta: {
                    title: '全部工时审批',
                    isBackend: false,
                    mustAuth: true,
                    hiddenToolbar: false,
                    showNav: true,
                    hidden: true,
                    index: 4,
                },
            },
            {
                path: 'examine',
                component: ()=>import('@/views/ManageExamine.vue'),
                name: 'examine',
                meta: {
                    title: '当日工时审批',
                    isBackend: false,
                    mustAuth: true,
                    hiddenToolbar: false,
                    showNav: true,
                    hidden: true,
                    index: 5,
                },
            },
            {
                path: 'project',
                component: ()=>import('@/views/ManageProjectList.vue'),
                name: 'projectlist',
                meta: {
                    title: '项目信息管理',
                    isBackend: false,
                    mustAuth: true,
                    hiddenToolbar: false,
                    showNav: true,
                    hidden: true,
                    index: 6,
                },
            },
            {
                path: 'project/:id',
                component: ()=>import('@/views/ManageProjectDetail.vue'),
                name: 'project',
                meta: {
                    title: '项目更新',
                    isBackend: false,
                    mustAuth: true,
                    hiddenToolbar: false,
                    showNav: true,
                    hidden: true,
                    index: 7,
                },
            },
            {
                path: 'performance',
                component: ()=>import('@/views/projectPerformance.vue'),
                name: 'project',
                meta: {
                    title: '项目绩效看板',
                    isBackend: false,
                    mustAuth: true,
                    hiddenToolbar: false,
                    showNav: true,
                    hidden: true,
                    index: 8,
                },
            },
        ]
    },

    /*==前台路由配置 End==*/

    /*==管理后台路由配置 Start==*/
    {
        path: '/admin/login',
        component: ()=>import('@/views/admin/login.vue'),
        name: 'admin_login',
        meta: {
            title: '系统登陆',
            isBackend: true,
            mustAuth: false
        },
        hidden: true,
        index: 0,
    },
    {
        path: '/admin',
        component: Backend,
        name: 'admin',
        meta: {
            title: '基本配置',
            isBackend: true,
            mustAuth: true,
        },
        iconCls: 'el-icon-setting',//图标样式class
        index: 0,
        redirect: '/admin/employee',
        children: [
            {
                path: 'employee',
                name: 'employee',
                component: ()=>import('@/views/admin/employee/employeeManage.vue'),
                meta: {
                    title: '员工信息管理',
                    isBackend: true,
                    mustAuth: true
                },
                index: 1,
            },
            {
                path: 'customer',
                name: 'customer',
                component: ()=>import('@/views/admin/customer/customerManage.vue'),
                meta: {
                    title: '客户信息管理',
                    isBackend: true,
                    mustAuth: true
                },
                index: 2,
            },
            {
                path: 'elc',
                name: 'elc',
                component: ()=>import('@/views/admin/elc/employeeLevelConfig.vue'),
                meta: {
                    title: '员工级别配置',
                    isBackend: true,
                    mustAuth: true
                },
                index: 3,
            },

            {
                path: 'infoManage',
                name: 'infoManage',
                component: ()=>import('@/views/admin/department/InfoManage.vue'),
                meta: {
                    title: '部门信息管理',
                    isBackend: true,
                    mustAuth: true
                },
                index: 4
            },
            {
                path: 'contractManage',
                name: 'contractManage',
                component: ()=>import('@/views/admin/contract/contractManage.vue'),
                meta: {
                    title: '合同信息管理',
                    isBackend: true,
                    mustAuth: true
                },
                index:5
            },
            {
                path: 'holidayConfig',
                name: 'holidayConfig',
                component: ()=>import('@/views/admin/sys/holidayConfig.vue'),
                meta: {
                    title: '节假日配置',
                    isBackend: true,
                    mustAuth: true
                },
                index: 6,
            },

        ]
    },
    {
        path: '/admin',
        component: Backend,
        name: "admin",
        meta: {
            title: '项目管控',
            isBackend: true,
            mustAuth: true
        },
        iconCls: "el-icon-s-operation",
        index: 1,
        redirect: '/admin/project',
        children: [
            {
                path: 'project',
                name: 'project',
                component: ()=>import('@/views/admin/project/projectManage.vue'),
                meta: {
                    title: '项目信息管理',
                    isBackend: true,
                    mustAuth: true
                },
                index: 1,
            },
            {
                path: 'progress',
                name: 'progress',
                component: ()=>import('@/views/admin/project/ProjectProgress.vue'),
                meta: {
                    title: '项目执行管理',
                    isBackend: true,
                    mustAuth: true
                },
                index: 2,
            },
            {
                path: 'consume',
                name: 'consume',
                component: ()=>import('@/views/admin/employee/consumeManage.vue'),
                meta: {
                    title: '工时审批管理',
                    isBackend: true,
                    mustAuth: true
                },
                index: 3,
            },
        ]
    },
    {
        path: '/admin',
        component: Backend,
        name: "admin",
        meta: {
            title: "报表查看",
            isBackend: true,
            mustAuth: true,
        },
        iconCls: 'el-icon-document',
        index: 2,
        children: [
            {
                path: 'availability',
                name: 'availability',
                component: ()=>import('@/views/admin/employee/EmployeeAvailability.vue'),
                meta: {
                    title: '人员绩效情况',
                    isBackend: true,
                    mustAuth: true
                },
                index: 1
            },
            {
                path: 'report',
                name: 'report',
                component: ()=>import('@/views/admin/finance/depFinanceReport.vue'),
                meta: {
                    title: '部门绩效情况',
                    isBackend: true,
                    mustAuth: true
                },
                index: 2
            },
            {
                path: 'angle',
                name: 'angle',
                component: ()=>import('@/views/admin/angle/AngleInfo.vue'),
                meta: {
                    title: "项目执行情况",
                    isBackend: true,
                    mustAuth: true
                },
                index: 3
            },
            {
                path: 'fill',
                name: 'fill',
                component: ()=>import('@/views/admin/finance/EmployeeFillIn.vue'),
                meta: {
                    title: '人员填写情况',
                    isBackend: true,
                    mustAuth: true
                },
                index: 4
            }
        ]
    },
    /*==管理后台路由配置 End==*/

    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

const router = new VueRouter({
    routes
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js